import TripChangeEuRailTicket from './trip-change-eurail-ticket-component';
import TripChangeEuRailTicketService from './trip-change-eurail-ticket-service';

import './trip-change-eurail-ticket-modal.scss';

const MODULE_NAME = 'app.trip.change-eurail-ticket';
const module = angular.module(MODULE_NAME, [])
    .directive(TripChangeEuRailTicket.DIRECTIVE_NAME, TripChangeEuRailTicket)
    .service('tripChangeEuRailTicketService', TripChangeEuRailTicketService);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/trip/trip-change-eurail-ticket/trip-change-eurail-ticket-module.js